import { SvgIcon, type SvgIconProps } from "@mui/material";

interface ESportsProps extends SvgIconProps {
  variant?: "regular" | "bold";
}

export function ESports({ variant = "regular", ...props }: ESportsProps) {
  const pathData =
    variant === "bold"
      ? [
          {
            id: "controller",
            path: "M21.5798 16.09L20.4898 8.43C20.2098 6.46 18.5198 5 16.5298 5H7.46982C5.47982 5 3.78982 6.46 3.50982 8.43L2.41982 16.09C2.19982 17.63 3.38982 19 4.93982 19C5.61982 19 6.25982 18.73 6.73982 18.25L8.99982 16H14.9998L17.2498 18.25C17.7298 18.73 18.3798 19 19.0498 19C20.6098 19 21.7998 17.63 21.5798 16.09ZM10.9998 11H8.99982V13H7.99982V11H5.99982V10H7.99982V8H8.99982V10H10.9998V11ZM14.9998 10C14.4498 10 13.9998 9.55 13.9998 9C13.9998 8.45 14.4498 8 14.9998 8C15.5498 8 15.9998 8.45 15.9998 9C15.9998 9.55 15.5498 10 14.9998 10ZM16.9998 13C16.4498 13 15.9998 12.55 15.9998 12C15.9998 11.45 16.4498 11 16.9998 11C17.5498 11 17.9998 11.45 17.9998 12C17.9998 12.55 17.5498 13 16.9998 13Z",
          },
        ]
      : [
          {
            id: "controller",
            path: "M21.5801 16.09L20.4901 8.43C20.2101 6.46 18.5201 5 16.5301 5H7.47006C5.48006 5 3.79007 6.46 3.51007 8.43L2.42007 16.09C2.20007 17.63 3.39007 19 4.94007 19C5.62007 19 6.26006 18.73 6.74006 18.25L9.00006 16H15.0001L17.2501 18.25C17.7301 18.73 18.3801 19 19.0501 19C20.6101 19 21.8001 17.63 21.5801 16.09ZM19.4801 16.81C19.4001 16.9 19.2701 17 19.0601 17C18.9101 17 18.7701 16.94 18.6701 16.84L15.8301 14H8.17006L5.33007 16.84C5.23007 16.94 5.09007 17 4.94007 17C4.73007 17 4.60006 16.9 4.52007 16.81C4.44007 16.72 4.36006 16.58 4.39006 16.37L5.48007 8.71C5.63007 7.74 6.48006 7 7.47006 7H16.5301C17.5201 7 18.3701 7.74 18.5101 8.72L19.6001 16.38C19.6301 16.58 19.5501 16.72 19.4801 16.81Z",
          },
          {
            id: "dpad",
            path: "M9.00006 8H8.00006V10H6.00007V11H8.00006V13H9.00006V11H11.0001V10H9.00006V8Z",
          },
          {
            id: "button-a",
            path: "M17.0001 13C17.5523 13 18.0001 12.5523 18.0001 12C18.0001 11.4477 17.5523 11 17.0001 11C16.4478 11 16.0001 11.4477 16.0001 12C16.0001 12.5523 16.4478 13 17.0001 13Z",
          },
          {
            id: "button-b",
            path: "M15.0001 10C15.5523 10 16.0001 9.55228 16.0001 9C16.0001 8.44772 15.5523 8 15.0001 8C14.4478 8 14.0001 8.44772 14.0001 9C14.0001 9.55228 14.4478 10 15.0001 10Z",
          },
        ];

  return (
    <SvgIcon
      {...props}
      viewBox="0 0 24 24"
      sx={{
        color: "white",
        fontSize: "24px",
        ...props.sx,
      }}
    >
      {pathData.map((item) => (
        <path key={item.id} d={item.path} />
      ))}
    </SvgIcon>
  );
}
